<div class='wrapperAddAnother o-color-{{color}}' (click)='disabled ? null : emit.emit()'
     [class.o-cur-default-important]='disabled'>
  <!--  <meSvg svgName='plus_green&20'></meSvg>-->
  <meSvg [svgName]='svgLeft!'></meSvg>
  Add Another
</div>